import { CommonModule } from "@angular/common";
import { Component, Input, signal } from "@angular/core";


@Component({
    selector: 'app-toast',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class Toast{
    @Input() message: string = '';
    @Input() type: string = 'success'; // can be 'success', 'error', 'info', etc.
    isVisible = signal<boolean>(false);

    show() {
        this.isVisible.set(true);
        setTimeout(() => this.hide(), 5000); // Hide after 5 seconds
    }
    
    hide() {
       this.isVisible.set(false);
    }

    getToastClass() {
        return {
          'bg-success': this.type === 'success',
          'bg-danger': this.type === 'error',
          'bg-info': this.type === 'info',
          'bg-warning': this.type === 'warning',
        };
    }
}